(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name smsManager.service:SmsManagerService
   *
   * @description
   *
   */
  angular.module('smsManager').service('SmsManagerService', SmsManagerService);

  function SmsManagerService(SmsManagerFactory, CrewingHelper, RemoteService) {

    var self = this;

    // store retrieved data
    var model = {
      formattedMessageList : [],
      messageAdminSearchRequest : SmsManagerFactory.getSmsManagerSearchRequest(),
      messageStatusList : null
    };

    self.setSmsManagerSearchRequest = function(searchCrieteria) {
      model.messageAdminSearchRequest = SmsManagerFactory.getFormattedSmsManagerSearchRequest(searchCrieteria);
    };

    self.searchMessages = function(successFn, errorFn) {
      CrewingHelper.searchSMSList(model.messageAdminSearchRequest, function(data) {
          if (!!data) {
            successFn(data);
          }
        },
        function(error) {
          errorFn(error.msg[0]);
        });
    };

    self.searchMessageStatus = function (successFn, errorFn) {
      if (model.messageStatusList === null) {
        RemoteService.getSmsManagerStatus().then(
          function (response) {
            model.messageStatusList = response.messageStatusList;
            successFn(model.messageStatusList);
          },
          function (error) {
            errorFn(error.msg[0]);
          }
        );
      } else {
        successFn(model.messageStatusList);
      }
    };

    self.getFormattedMessageList = function(messages){
    	model.formattedMessageList = SmsManagerFactory.getFormattedMessageList(messages);
    	return model.formattedMessageList;
    };

    self.appendToGridMessageList = function (existingGridMessageData, newGridMessageData) {
      angular.forEach(newGridMessageData, function (messageObj) {
        var foundMessageIndex = _.findIndex(existingGridMessageData, {smsId: messageObj.smsId})
        if (foundMessageIndex >= 0) {
          existingGridMessageData.splice(foundMessageIndex, 1, messageObj);
        } else {
          existingGridMessageData.push(messageObj);
        }
      });
    };

  }
})();
